import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-disqus]';
export const PLUGIN_NAME = 'disqus';

import debug from 'debug';
import plugin from '@core/plugins/lib';
import { onAvailable } from "@core/plugins/lib/selectors";


const log = debug('components/disqus');

class Disqus {
	constructor(element, options) {
		this.options = options;

		this.init();
	}

	init() {
		log('init', this.options);

		const config = this.options.pageConfig;

		window.disqus_config = function(){
			for (const prop in config) {
				this.page[prop] = config[prop];
			}
		};

		var dsq = document.createElement('script');
		dsq.type = 'text/javascript';
		dsq.async = true;
		dsq.src = '//' + this.options.shortname + '.disqus.com/embed.js';
		dsq.setAttribute('data-timestamp', +new Date());
		(
			document.getElementsByTagName('head')[0] ||
			document.getElementsByTagName('body')[0]
		).appendChild(dsq);
	}
}

Disqus.DEFAULTS = {};

//plugin(PLUGIN_NAME, Disqus);

// $(document).ready(() => {
// 	$(ELEMENT_SELECTOR).each(function() {
// 		const element = this;
// 		$(element)[PLUGIN_NAME]();
// 	});
// });

$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		plugin(PLUGIN_NAME, Disqus);
			$(element)[PLUGIN_NAME]();		
	});
});


// WEBPACK FOOTER //
// ./project/client/src/site__ale001/components/blocks/disqus/index.js